/**
 * Simple preloader utility for performance optimizations
 * Minimal implementation focused on critical resource preloading
 */

// Simple font preloader for better typography performance
export const preloadCriticalFonts = () => {
  const criticalFonts = [
    '/fonts/tt-norms/TTNorms-Regular.otf',
    '/fonts/tt-norms/TTNorms-Medium.otf'
  ];

  criticalFonts.forEach(fontUrl => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/otf';
    link.crossOrigin = 'anonymous';
    link.href = fontUrl;
    document.head.appendChild(link);
  });
};

// Preload critical assets for first section only
export const preloadFirstSection = (project) => {
  if (!project?.projectContent?.sections?.[0]) return;

  const firstSection = project.projectContent.sections[0];
  
  if (firstSection.type === 'media' || firstSection.type === 'Video') {
    const mediaUrl = firstSection.media || firstSection.imageName;
    
    if (mediaUrl) {
      // Preload first media asset only
      if (mediaUrl.endsWith('.mp4') || mediaUrl.endsWith('.webm')) {
        // For videos, just create the element to start loading
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = mediaUrl;
      } else {
        // For images, use link preload
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = mediaUrl;
        document.head.appendChild(link);
      }
    }
  }
};

// Performance monitoring (optional)
export const getPerformanceMetrics = () => {
  if ('performance' in window) {
    const navigation = performance.getEntriesByType('navigation')[0];
    return {
      domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
      loadComplete: navigation.loadEventEnd - navigation.loadEventStart,
      totalTime: navigation.loadEventEnd - navigation.fetchStart
    };
  }
  return null;
};

export default {
  preloadCriticalFonts,
  preloadFirstSection,
  getPerformanceMetrics
};
